export const toTitleCase = (string_: string): string => {
  return string_.toLowerCase().replaceAll(/(?:^|\s)\w/g, function (match) {
    return match.toUpperCase();
  });
};
